/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View } from '@components/atoms'
import { FullModalLayout, ResetPasswordTextField } from '@components/molecules'
import { mono, boShared } from '@components/systems/backoffice/backoffice.tokens'

import {
	useAppDispatch,
	useAppSelector,
	routeActions,
	customerActions,
} from '@redux/index'
import { Validator, ValidatorResultType } from '@validators'

import { CustomerType } from '@schemas'

const ResetMainCustomerPasswordPage = () => {
	// redux dispatch
	const reduxDispatch = useAppDispatch()

	// redux state
	const customerInfo: CustomerType = useAppSelector(
		state => state.customer.editPasswordCustomer,
	)
	const resetPasswordErrorMessage: string = useAppSelector(
		state => state.customer.resetPasswordErrorMessage,
	)

	// state
	const [password, setPassword] = React.useState<string>('')

	React.useEffect(() => {
		if (['', undefined, null].includes(customerInfo.id)) {
			onCloseClick()
		}
	}, [customerInfo])

	const onCloseClick = React.useCallback(() => {
		reduxDispatch(routeActions.NAVIGATE_PATH('/main/customer'))
	}, [])

	const onResetPasswordChange = (str: string) => {
		setPassword(str)
	}

	const onResetPasswordSubmitClick = () => {
		const res: ValidatorResultType = Validator.customer({
			password: password,
		})

		if (res['password'].isValid) {
			reduxDispatch(
				customerActions.UPDATE_RESET_PASSWORD({
					customerId: customerInfo.id,
					password: password,
				}),
			)
		} else {
			reduxDispatch(customerActions.RESET_PASSWORD_ERROR_MESSAGE(res['password'].message))
		}
	}

	return (
		<View css={style}>
			<FullModalLayout
				title="패스워드 변경"
				onCloseClick={onCloseClick}
				titleStyle={{ marginBottom: '1rem' }}
			>
				<View className="resetPasswordOuterView">
					<View className="boField textFieldView">
						<label className="boLabel" htmlFor="resetCustomerId">
							ID (수정 불가)
						</label>
						<input
							id="resetCustomerId"
							className="boInput readOnly"
							defaultValue={customerInfo.id}
							readOnly
						/>
					</View>

					<View className="textFieldView">
						<ResetPasswordTextField
							label="패스워드"
							onChange={onResetPasswordChange}
							isResetPassword={true}
							variant="standard"
							errorMessage={resetPasswordErrorMessage}
						/>
					</View>

					<View className="bottomView">
						<button type="button" className="boBtn" onClick={onResetPasswordSubmitClick}>
							패스워드 저장
						</button>
					</View>
				</View>
			</FullModalLayout>
		</View>
	)
}

export default ResetMainCustomerPasswordPage

const style = css({
	...boShared,

	'.resetPasswordOuterView': {
		position: 'relative',
		height: 'fit-content',
		overflow: 'auto',
		textAlign: 'left',

		'.textFieldView': {
			marginBottom: 28,
		},

		'.boInput.readOnly': {
			color: mono.faint,
			borderBottomColor: mono.line,
		},

		'.bottomView': {
			display: 'flex',
			justifyContent: 'flex-end',
			alignItems: 'center',
			width: '100%',
			marginTop: 40,
		},
	},
})
